/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemMultipleSelectionErrorMessage } from './formPagePropertyItemMultipleSelectionErrorMessage';
import { FormPagePropertyItemMultipleSelectionInputFormat } from './formPagePropertyItemMultipleSelectionInputFormat';
import { FormPagePropertyItemMultipleSelectionCandidate } from './formPagePropertyItemMultipleSelectionCandidate';
import { FormPagePropertyItemSelectionRequiredSubtext } from './formPagePropertyItemSelectionRequiredSubtext';
import { FormPagePropertyItemMultipleSelectionItemDefinition } from './formPagePropertyItemMultipleSelectionItemDefinition';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';


/**
 * 複数選択型の入力項目を表す。 
 */
export interface FormPagePropertyItemMultipleSelection { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'multipleSelection';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemMultipleSelection.TypeEnum;
    items: FormPagePropertyItemMultipleSelectionItemDefinition;
    /**
    * 最小選択数. これを下回る選択数だとエラー(ただし非必須の場合は未選択 = 空配列も許容しないといけない）
    */
    minItems?: number;
    /**
    * 最大選択数. これを上回る選択数だとエラー
    */
    maxItems?: number;
    /**
    * 配列内に重複を許すかどうか true固定で入れる https://json-schema.org/understanding-json-schema/reference/array.html#uniqueness 
    */
    uniqueItems?: boolean;
    inputFormat: FormPagePropertyItemMultipleSelectionInputFormat;
    candidates: Array<FormPagePropertyItemMultipleSelectionCandidate>;
    errorMessage?: FormPagePropertyItemMultipleSelectionErrorMessage;
    /**
    * 補助テキストが必須となる選択肢と、選択肢ごとのエラーメッセージの配列. 補助テキストの必須判定に利用
    */
    requiredSubtextMultipleSelection?: Array<FormPagePropertyItemSelectionRequiredSubtext>;
}

export namespace FormPagePropertyItemMultipleSelection {
    export type TypeEnum = 'array';
    export const TypeEnum = {
        Array: 'array' as TypeEnum
    };
}


